module.exports = __webpack_public_path__ + "media/img/home/sections-parralax/directions-parralax-cb8211b73c5b938a84621e8aceee9a5a.png";